import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  // JSON.parse(localStorage.getItem("darkMode")) || false;
  darkMode: false,

  tableModal: true,
  tableModalTab: 0,
  thoughtTab: 0,

  customModal: false,
  modalTitle: null,
  modalType: null,
  participantsType: null,

  participantsCount: null,
  participantsId: null,
  // ownerId: null,

  loadNavigation: false,

  snackbarMode: false,
  snackbarTitle: null,

  profileTab: 1,

  categoryIdMain: null,
  categoryExplor: null,

  searchExplore: "",

  alertDialog: false,
  alertDialogData: null,

  userData: null,
  userName: null,

  error404: false,

  localAvatar: null,

  replyComment: null,
  cmState: null,

  profileId: null,
  commentId: null,

  appAlert: true,
};

export const settingSlice = createSlice({
  name: "setting",
  initialState,

  reducers: {
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
    },

    setTableModal: (state, action) => {
      state.tableModal = action.payload;
    },
    setTableModalTab: (state, action) => {
      state.tableModalTab = action.payload;
    },
    setThoughtTab: (state, action) => {
      state.thoughtTab = action.payload;
    },

    setCustomModal: (state, action) => {
      state.customModal = action.payload;
    },
    setModalTitle: (state, action) => {
      state.modalTitle = action.payload;
    },
    setModalType: (state, action) => {
      state.modalType = action.payload;
    },
    setParticipantsType: (state, action) => {
      state.participantsType = action.payload;
    },

    setParticipantsCount: (state, action) => {
      state.participantsCount = action.payload;
    },
    setParticipantsId: (state, action) => {
      state.participantsId = action.payload;
    },
    // setOwnerId: (state, action) => {
    //   state.ownerId = action.payload;
    // },

    setLoadNavigation: (state, action) => {
      state.loadNavigation = action.payload;
    },

    setSnackbarMode: (state, action) => {
      state.snackbarMode = action.payload;
    },
    setSnackbarTitle: (state, action) => {
      state.snackbarTitle = action.payload;
    },

    setProfileTab: (state, action) => {
      state.profileTab = action.payload;
    },

    setCategoryIdMain: (state, action) => {
      state.categoryIdMain = action.payload;
    },
    setCategoryExplor: (state, action) => {
      state.categoryExplor = action.payload;
    },

    setSearchExplore: (state, action) => {
      state.searchExplore = action.payload;
    },

    setAlertDialog: (state, action) => {
      state.alertDialog = action.payload;
    },
    setAlertDialogData: (state, action) => {
      state.alertDialogData = action.payload;
    },

    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },

    setError404: (state, action) => {
      state.error404 = action.payload;
    },

    setLocalAvatar: (state, action) => {
      state.localAvatar = action.payload;
    },

    setReplyComment: (state, action) => {
      state.replyComment = action.payload;
    },
    setCmState: (state, action) => {
      state.cmState = action.payload;
    },

    setProfileId: (state, action) => {
      state.profileId = action.payload;
    },
    setCommentId: (state, action) => {
      state.commentId = action.payload;
    },

    setAppAlert: (state, action) => {
      state.appAlert = action.payload;
    },
  },
});

export const getSettingState = (state) => state.setting;
export const {
  setDarkMode,

  setTableModal,
  setTableModalTab,
  setThoughtTab,

  setCustomModal,
  setModalTitle,
  setModalType,
  setParticipantsType,

  setParticipantsCount,
  setParticipantsId,
  // setOwnerId,

  setLoadNavigation,

  setSnackbarMode,
  setSnackbarTitle,

  setProfileTab,

  setCategoryIdMain,
  setCategoryExplor,

  setSearchExplore,

  setAlertDialog,
  setAlertDialogData,

  setUserData,
  setUserName,

  setError404,

  setLocalAvatar,

  setReplyComment,
  setCmState,

  setProfileId,
  setCommentId,

  setAppAlert,
} = settingSlice.actions;

export default settingSlice.reducer;
